import { Box } from "@mui/material";
import AdminCrossPlay from "./AdminCrossPlay";

export default function AdminCrossPlayMain() {
    return (
        <Box>
            <AdminCrossPlay />
        </Box>
    );
}

